import {Alert, useOpenModal} from '@/components/Modal'
import Color from '../Color.mjs'
import extendNode from '../extendNode.mjs'
import useCommonNode from '../_COMMON/useCommonNode.jsx'
import meta from './metaOld.mjs'
import ModalSheet from './ModalSheet.jsx'
import Model from './ModelOld.mjs'
import OldType from './OldType.jsx'
import PropertiesPane from './PropertiesPaneOld.jsx'

const oldTypes = new Map(
    OldType.map(([type, name, icon]) => [type, {icon, name, type}])
)

export default () => {
    const openModal = useOpenModal()
    const CommonNode = useCommonNode()

    return extendNode(CommonNode, {
        ...meta,
        Model,
        PropertiesPane,

        getStyle(map, node) {
            return {
                ...CommonNode.getStyle.call(this, map, node),
                borderColor: Color.CYAN,
            }
        },

        getIcons(map, node) {
            const {type} = node.data
            const {icon} = oldTypes.get(type) ?? {}

            if (icon) {
                return [icon]
            }
            else {
                return []
            }
        },

        async onDoubleClick(map, node, event) {
            event.preventDefault()
            const {content, text, type} = node.data

            if (! type) {
                await openModal(
                    <Alert type="error">请先设置在线数据类型</Alert>
                )

                return
            }

            const Modal = {
                SHEET: ModalSheet,
            }[type]

            if (! Modal) {
                await openModal(
                    <Alert type="error">无法识别的数据类型: {type}</Alert>
                )

                return
            }

            let data

            try {
                data = JSON.parse(content)
            }
            catch (err) {
                await openModal(
                    <Alert type="error">没有数据</Alert>
                )

                console.log(err)
                return
            }

            if (! data) {
                await openModal(
                    <Alert type="error">没有数据</Alert>
                )

                return
            }

            const newData = await openModal(
                <Modal
                    data={data}
                    title={text}
                />
            )

            if (! newData) {
                return
            }

            map.execute(() => {
                node.data = {
                    ...node.data,
                    content: JSON.stringify(newData),
                }
            })
        },
    })
}
